/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 6/4/17
 * Copyright All Rights Reserved
 */

import { combineReducers } from 'redux';
import siteReducer from './siteReducer';

const entitiesReducer = combineReducers({
  reports: siteReducer,
});

export default entitiesReducer;
